import { Card, CardBody, Table, TabPane } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import CreateHiringSourceModal from "../Modals/CreateHiringSource";
import IconButton from "../../../../../components/Buttons/IconButton";
import { IoCreateOutline } from "react-icons/io5";
import { BsTrash3 } from "react-icons/bs";
import ConfirmationModal from "../../../../../components/Modals/Confirmation";
import { del } from "../../../../../utils/helpers/api";
import { toast } from "react-toastify";

function HiringSourcesTab({ hiringSources, refreshSettings }) {
  const { t } = useTranslation();
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [hiringSourceToDelete, setHiringSourceToDelete] = useState(null);
  const [hiringSourceToEdit, setHiringSourceToEdit] = useState(null);

  const deleteHiringSource = async () => {
    const data = await del(`/hr/hiring-sources/delete/${hiringSourceToDelete}`);
    if(data?.success) {
      refreshSettings();
      setHiringSourceToDelete(null);
      toast.success(t('hr.settings.hiringSources.deleted'));
    }
  }

  return(
    <TabPane tabId="hiring-sources">
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="text-muted small fw-semibold text-uppercase mb-0">
              Hiring Sources
            </p>
            <DefaultButton
              color="primary"
              size="sm"
              onClick={() => {
                setHiringSourceToEdit(null);
                setCreateModalOpen(true);
              }}
            >
              + { t('common.create') }
            </DefaultButton>
          </div>

          <Table hover responsive className="mb-0">
            <thead className="table-light">
              <tr>
                <th>{ t('common.name') }</th>
                <th>{ t('timeline.createdBy') }</th>
                <th>{ t('common.actions') }</th>
              </tr>
            </thead>
            <tbody>
              {hiringSources?.map(hiringSource => (
                <tr key={hiringSource?.id}>
                  <td>{ hiringSource?.name }</td>
                  <td>{ hiringSource?.created_by?.name }</td>
                  <td>
                    <div className="d-flex align-items-center gap-2 h-100">
                      <IconButton
                        size="sm" 
                        outline 
                        color="secondary"
                        onClick={() => {
                          setHiringSourceToEdit(hiringSource);
                          setCreateModalOpen(true);
                        }}
                      >
                        <IoCreateOutline />
                      </IconButton>
                      <IconButton
                        size="sm" 
                        outline 
                        color="danger"
                        onClick={() => setHiringSourceToDelete(hiringSource.id)}
                      >
                        <BsTrash3 />
                      </IconButton>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>

      <CreateHiringSourceModal 
        isOpen={createModalOpen}
        toggle={() => setCreateModalOpen(!createModalOpen)}
        hiringSourceToEdit={hiringSourceToEdit}
        refreshSettings={refreshSettings}
      />

      <ConfirmationModal
        isOpen={hiringSourceToDelete !== null}
        title={t('hr.settings.hiringSources.deleteTitle')}
        message={t('hr.settings.hiringSources.deleteMessage')}
        onConfirm={deleteHiringSource}
        toggle={() => setHiringSourceToDelete(null)}
      />
    </TabPane>
  );
}

export default HiringSourcesTab;